import { DigitalRevisionMenuItem } from '../interfaces/digital-revision-menu-item';
import { ProxyTypeEnum } from '../interfaces/proxy-type-enum';
import { MenuItemTypeEnum } from '../interfaces/menu-item-type-enum';
import { TestLevelEnum } from '../interfaces/test-level-enum';

export const HomePageMenuItems: DigitalRevisionMenuItem[] = [
  {
    MenuItemType: MenuItemTypeEnum.QuickQuiz,
    IsFreeSample: false,
    Anchor: '',
    ButtonColour: '',
    ButtonCustomClasses: '',
    ButtonText: 'Take a Quick Quiz',
    ButtonURL: 'quick-quiz',
    MixedOnlineTests: [
      {
        MixedOnlineTestUrl: '_revisionhub_opc/SPAS43/SPAS43_QuickQuiz_v3',
        Proxy: ProxyTypeEnum.CFProxy,
      },
    ],

    HasData: true,
    HeadingText: 'Quick Quizzes',
    IsButtonDisabled: false,
    IsSwitcher: false,
    MainContentText:
      'Test yourself on all the required vocab and grammar. On your marks, get set... quiz!\n' +
      '\n' +
      'Questions answered: <strong>[[variable1]]</strong></p>\n' +
      '\n' +
      'Last quiz score: <strong>[[variable2]]</strong>',
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'Vocab and grammar questions',
    SwitcherCookieName: 'CgpDigitalRevision',
    SwitcherProductCode: '',
    ExtrasOrAnswers: {
      HeaderText: '',
      ContentMain: '',
      ContentRight: {
        ImageUrl: '',
        AltText: '',
      },
    },
    HowToUseThisBook: {
      Text: '',
      VideoLink: '',
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        Intro: '',
        Title: '',
        LeftSections: [],
        RightSections: [],
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      IntroTitle: 'Listening Tracks',
      Intro: '',
      ProductTitle: '',
      AdditionalInfo: '',
      TrackFilePaths: [],
    },
    MenuBar: [
      {
        Text: 'Home',
        ImagePath: '/assets/images/landing/home.png',
        DestinationPage: '',
      },
      {
        Text: 'Quick Quiz',
        ImagePath: '/assets/images/landing/quick-quizzes.png',
        DestinationPage: 'Quick-Quiz',
      },
      {
        Text: 'Mistakes Quiz',
        ImagePath: '/assets/images/landing/your-mistakes-quiz.png',
        DestinationPage: 'Mistakes-Quiz',
        MenuType: MenuItemTypeEnum.MistakesQuiz,
      },
      {
        Text: 'Summary Test',
        ImagePath: '/assets/images/landing/revision-summary-test.png',
        DestinationPage: 'Revision-Summary-Test',
      },
      {
        Text: 'Level',
        ImagePath: '/assets/images/landing/h-f-level.png',
        DestinationPage: 'CookieSwitcher',
      },
    ],
    HowToRevise: {
      DisplayName: '',
      BookType: '',
      AdditionalText: '',
    },
  },
  {
    MenuItemType: MenuItemTypeEnum.MistakesQuiz,
    IsFreeSample: false,
    Anchor: '',
    ButtonColour: '#F0542C',
    ButtonCustomClasses: '',
    ButtonText: 'Go to Your Mistakes Quiz',
    ButtonURL: 'mistakes-quiz',
    MixedOnlineTests: [
      {
        MixedOnlineTestUrl: '_revisionhub_opc/SPAS43/SPAS43_Mistakes_v3',
        Proxy: ProxyTypeEnum.CFProxy,
      },
    ],

    HasData: true,
    HeadingText: 'Your Mistakes Quiz',
    IsButtonDisabled: false,
    IsSwitcher: false,
    MainContentText:
      '<p>The quick quiz questions you got wrong are here &mdash; have another go and conquer them once and for all!</p>\n' +
      '<p>Total questions stored: <strong>[[variable1]]</strong></p>\n' +
      '<p>Total questions answered: <strong>[[variable2]]</strong><br />\n',
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'Correct your wrong answers\n',
    SwitcherCookieName: 'CgpDigitalRevision',
    SwitcherProductCode: '',
    ExtrasOrAnswers: {
      HeaderText: '',
      ContentMain: '',
      ContentRight: {
        ImageUrl: '',
        AltText: '',
      },
    },
    HowToUseThisBook: {
      Text: '',
      VideoLink: '',
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        Intro: '',
        Title: '',
        LeftSections: [],
        RightSections: [],
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      IntroTitle: 'Listening Tracks',
      Intro: '',
      ProductTitle: '',
      AdditionalInfo: '',
      TrackFilePaths: [],
    },
    MenuBar: [
      {
        Text: 'Home',
        ImagePath: '/assets/images/landing/home.png',
        DestinationPage: '',
      },
      {
        Text: 'Quick Quiz',
        ImagePath: '/assets/images/landing/quick-quizzes.png',
        DestinationPage: 'Quick-Quiz',
      },
      {
        Text: 'Mistakes Quiz',
        ImagePath: '/assets/images/landing/your-mistakes-quiz.png',
        DestinationPage: 'Mistakes-Quiz',
        MenuType: MenuItemTypeEnum.MistakesQuiz,
      },
      {
        Text: 'Summary Test',
        ImagePath: '/assets/images/landing/revision-summary-test.png',
        DestinationPage: 'Revision-Summary-Test',
      },
      {
        Text: 'Level',
        ImagePath: '/assets/images/landing/h-f-level.png',
        DestinationPage: 'CookieSwitcher',
        MenuType: MenuItemTypeEnum.HighFoundationSwitch,
      },
    ],
    HowToRevise: {
      DisplayName: '',
      BookType: '',
      AdditionalText: '',
    },
  },
  {
    MenuItemType: MenuItemTypeEnum.RevisionSummary,
    IsFreeSample: false,
    Anchor: '',
    ButtonColour: '',
    ButtonCustomClasses: '',
    ButtonText: 'Go to Revision Summary Tests',
    ButtonURL: 'revision-summary-test',
    MixedOnlineTests: [
      {
        MixedOnlineTestUrl: '_revisionhub_opc/SPAS43/SPAS43_RevSum_v2',
        Proxy: ProxyTypeEnum.CFProxy,
      },
    ],

    HasData: true,
    HeadingText: 'Revision Summary Test',
    IsButtonDisabled: false,
    IsSwitcher: false,
    MainContentText:
      '<p>See how well you understand each section. Mark your answers with our examples.</p>\n' +
      '<p>Questions answered: <strong>[[variable1]]</strong></p>\n' +
      '<p>Questions marked <img src="assets/images/smiley-face-green.png" width="30" height="30" style="vertical-align:middle;" /> : <strong>[[variable2]]</strong><br />\n',
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'In-depth written questions',
    SwitcherCookieName: 'CgpDigitalRevision',
    SwitcherProductCode: '',
    ExtrasOrAnswers: {
      HeaderText: '',
      ContentMain: '',
      ContentRight: {
        ImageUrl: '',
        AltText: '',
      },
    },
    HowToUseThisBook: {
      Text: '',
      VideoLink: '',
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        Intro: '',
        Title: '',
        LeftSections: [],
        RightSections: [],
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      IntroTitle: 'Listening Tracks',
      Intro: '',
      ProductTitle: '',
      AdditionalInfo: '',
      TrackFilePaths: [],
    },
    MenuBar: [
      {
        Text: 'Home',
        ImagePath: '/assets/images/landing/home.png',
        DestinationPage: '',
      },
      {
        Text: 'Quick Quiz',
        ImagePath: '/assets/images/landing/quick-quizzes.png',
        DestinationPage: 'Quick-Quiz',
      },
      {
        Text: 'Mistakes Quiz',
        ImagePath: '/assets/images/landing/your-mistakes-quiz.png',
        DestinationPage: 'Mistakes-Quiz',
        MenuType: MenuItemTypeEnum.MistakesQuiz,
      },
      {
        Text: 'Summary Test',
        ImagePath: '/assets/images/landing/revision-summary-test.png',
        DestinationPage: 'Revision-Summary-Test',
      },
      {
        Text: 'Level',
        ImagePath: '/assets/images/landing/h-f-level.png',
        DestinationPage: 'CookieSwitcher',
        MenuType: MenuItemTypeEnum.HighFoundationSwitch,
      },
    ],
    HowToRevise: {
      DisplayName: '',
      BookType: '',
      AdditionalText: '',
    },
  },
  {
    MenuItemType: MenuItemTypeEnum.OnlineEdition,
    IsFreeSample: false,
    Anchor: '',
    ButtonColour: '',
    ButtonCustomClasses: '',
    ButtonText: 'Go to Your Online Library',
    ButtonURL: '[[external_domain]]/bookspacedemo',
    MixedOnlineTests: [],

    HasData: false,
    HeadingText: 'Online Edition',
    IsButtonDisabled: false,
    IsSwitcher: false,
    MainContentText: '<p>Use your book wherever you are with your Online Edition — yippee!</p>\n',
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'Read your eBook here',
    SwitcherCookieName: 'CgpDigitalRevision',
    SwitcherProductCode: '',
    ExtrasOrAnswers: {
      HeaderText: '',
      ContentMain: '',
      ContentRight: {
        ImageUrl: '',
        AltText: '',
      },
    },
    HowToUseThisBook: {
      Text: '',
      VideoLink: '',
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        Intro: '',
        Title: '',
        LeftSections: [],
        RightSections: [],
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      IntroTitle: 'Listening Tracks',
      Intro: '',
      ProductTitle: '',
      AdditionalInfo: '',
      TrackFilePaths: [],
    },
    MenuBar: [],
    HowToRevise: {
      DisplayName: '',
      BookType: '',
      AdditionalText: '',
    },
  },
  {
    MenuItemType: MenuItemTypeEnum.QuestionAndAudio,
    IsFreeSample: false,
    Anchor: '',
    ButtonColour: '',
    ButtonCustomClasses: '',
    ButtonText: 'Go to videos',
    ButtonURL: 'question-and-audio',
    MixedOnlineTests: [],

    HasData: false,
    HeadingText: 'Q&A Audio',
    IsButtonDisabled: false,
    IsSwitcher: false,
    MainContentText: '<p>Watch these videos to help your listening and speaking skills.</p>\n',
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'Listen to native speakers',
    SwitcherCookieName: 'CgpDigitalRevision',
    SwitcherProductCode: '',
    ExtrasOrAnswers: {
      HeaderText: '',
      ContentMain: '',
      ContentRight: {
        ImageUrl: '',
        AltText: '',
      },
    },
    HowToUseThisBook: {
      Text: '',
      VideoLink: '',
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        Title: 'Q&A Audio',
        Intro:
          'Watch these videos to help improve your listening and pronunciation. They’re matched to the examples in your book — estupendo!',
        LeftSections: [
          {
            Header: 'Section One — General Stuff',
            Subcategories: [
              {
                Name: 'Times and Dates',
                ShortName: 'times-and-dates',
                Link: 'https://www.youtube.com/embed/UEPYNYQ_OU4?rel=0&modestbranding=1',
              },
              {
                Name: 'Questions',
                ShortName: 'questions',
                Link: 'https://www.youtube.com/embed/t0yoF3asM8M?rel=0&modestbranding=1',
              },
              {
                Name: 'Being Polite',
                ShortName: 'being-polite',
                Link: 'https://www.youtube.com/embed/c57wey3waKw?rel=0&modestbranding=1',
              },
              {
                Name: 'Opinions',
                ShortName: 'opinions',
                Link: 'https://www.youtube.com/embed/8kCH4dZNUuc?rel=0&modestbranding=1',
              },
            ],
          },
          {
            Header: 'Section Two — Identity and Relationships with Others',
            Subcategories: [
              {
                Name: 'My Family and Friends',
                ShortName: 'my-family-and-friends',
                Link: 'https://www.youtube.com/embed/fEPifq8A-Z0?rel=0&modestbranding=1',
              },
              {
                Name: 'Describing People',
                ShortName: 'describing-people',
                Link: 'https://www.youtube.com/embed/Rq4N8hxNkHA?rel=0&modestbranding=1',
              },
              {
                Name: 'Relationships and Partnerships',
                ShortName: 'relationships-and-partnerships',
                Link: 'https://www.youtube.com/embed/DTcq5Rfitfs?rel=0&modestbranding=1',
              },
            ],
          },
          {
            Header: 'Section Three — Healthy Living and Lifestyle',
            Subcategories: [
              {
                Name: 'Healthy and Unhealthy Living',
                ShortName: 'healthy-and-unhealthy-living',
                Link: 'https://www.youtube.com/embed/rLX2frDoyGk?rel=0&modestbranding=1',
              },
              {
                Name: 'Illnesses and Treatments',
                ShortName: 'illnesses-and-treatments',
                Link: 'https://www.youtube.com/embed/LT-7lRHZa2o?rel=0&modestbranding=1',
              },
            ],
          },
          {
            Header: 'Section Four — Education',
            Subcategories: [
              {
                Name: 'School Subjects',
                ShortName: 'school-subjects',
                Link: 'https://www.youtube.com/embed/hnVbhC-OT-k?rel=0&modestbranding=1',
              },
              {
                Name: 'School Life',
                ShortName: 'school-life',
                Link: 'https://www.youtube.com/embed/m7fCzGmNh1g?rel=0&modestbranding=1',
              },
              {
                Name: 'School Pressures and Difficulties',
                ShortName: 'school-pressures-and-difficulties',
                Link: 'https://www.youtube.com/embed/BytyFPxY2fU?rel=0&modestbranding=1',
              },
            ],
          },
          {
            Header: 'Section Five — Future Study and Work',
            Subcategories: [
              {
                Name: 'Education Post-16',
                ShortName: 'education-post-16',
                Link: 'https://www.youtube.com/embed/AeB0ihc5PDU?rel=0&modestbranding=1',
              },
              {
                Name: 'Career Choices and Ambitions',
                ShortName: 'career-choices-and-ambitions',
                Link: 'https://www.youtube.com/embed/RAIaJxCVfUo?rel=0&modestbranding=1',
              },
            ],
          },
          {
            Header: 'Section Six — Free-time Activities',
            Subcategories: [
              {
                Name: 'Cinema and TV',
                ShortName: 'cinema-and-tv',
                Link: 'https://www.youtube.com/embed/55yFo9PuDGU?rel=0&modestbranding=1',
              },
              {
                Name: 'Sport',
                ShortName: 'sport',
                Link: 'https://www.youtube.com/embed/k5j3w8ztVwY?rel=0&modestbranding=1',
              },
              {
                Name: 'Going Out and Other Hobbies',
                ShortName: 'going-out-and-other-hobbies',
                Link: 'https://www.youtube.com/embed/l8tft98c8Vg?rel=0&modestbranding=1',
              },
            ],
          },
        ],
        RightSections: [
          {
            Header: 'Section Seven — Customs, Festivals and Celebrations',
            Subcategories: [
              {
                Name: 'Celebrations',
                ShortName: 'celebrations',
                Link: 'https://www.youtube.com/embed/KyXVZrJwB6g?rel=0&modestbranding=1',
              },
              {
                Name: 'Customs and Festivals',
                ShortName: 'customs-and-festivals',
                Link: 'https://www.youtube.com/embed/wzooVUj53LA?rel=0&modestbranding=1',
              },
            ],
          },
          {
            Header: 'Section Eight — Celebrity Culture',
            Subcategories: [
              {
                Name: 'Favourite Celebrities',
                ShortName: 'favourite-celebrities',
                Link: 'https://www.youtube.com/embed/9gVvQhE7yd0?rel=0&modestbranding=1',
              },
              {
                Name: 'Celebrity Life',
                ShortName: 'celebrity-life',
                Link: 'https://www.youtube.com/embed/foEkdl-EnKE?rel=0&modestbranding=1',
              },
            ],
          },
          {
            Header: 'Section Nine — Travel and Tourism',
            Subcategories: [
              {
                Name: 'Where to Go',
                ShortName: 'where-to-go',
                Link: 'https://www.youtube.com/embed/6kfg2ybi3k8?rel=0&modestbranding=1',
              },
              {
                Name: 'Accommodation and Travel',
                ShortName: 'accommodation-and-travel',
                Link: 'https://www.youtube.com/embed/cllmAxAV6bA?rel=0&modestbranding=1',
              },
              {
                Name: 'Getting Around and What to Do',
                ShortName: 'getting-around-and-what-to-do',
                Link: 'https://www.youtube.com/embed/QUmT_NlF3EI?rel=0&modestbranding=1',
              },
            ],
          },
          {
            Header: 'Section Ten — Media and Technology',
            Subcategories: [
              {
                Name: 'Technology',
                ShortName: 'technology',
                Link: 'https://www.youtube.com/embed/lsnDuzZRJy8?rel=0&modestbranding=1',
              },
              {
                Name: 'The Internet',
                ShortName: 'the-internet',
                Link: 'https://www.youtube.com/embed/HJPEFqlZUzA?rel=0&modestbranding=1',
              },
              {
                Name: 'Social Media',
                ShortName: 'social-media',
                Link: 'https://www.youtube.com/embed/iiXa0HVUKQY?rel=0&modestbranding=1',
              },
            ],
          },
          {
            Header: 'Section Eleven — Where People Live',
            Subcategories: [
              {
                Name: 'At Home',
                ShortName: 'at-home',
                Link: 'https://www.youtube.com/embed/PrJeGG7Dgj0?rel=0&modestbranding=1',
              },
              {
                Name: 'The Local Area',
                ShortName: 'the-local-area',
                Link: 'https://www.youtube.com/embed/TXJqy15qMFM?rel=0&modestbranding=1',
              },
              {
                Name: 'Directions and Weather',
                ShortName: 'directions-and-weather',
                Link: 'https://www.youtube.com/embed/QUOa-HLNKYQ?rel=0&modestbranding=1',
              },
            ],
          },
          {
            Header: 'Section Twelve — Environmental and Social Issues',
            Subcategories: [
              {
                Name: 'Environmental Problems',
                ShortName: 'environmental-problems',
                Link: 'https://www.youtube.com/embed/le9i0s0EPTo?rel=0&modestbranding=1',
              },
              {
                Name: 'Protecting the Environment',
                ShortName: 'protecting-the-environment',
                Link: 'https://www.youtube.com/embed/c2MK582RFTc?rel=0&modestbranding=1',
              },
              {
                Name: 'Social Issues',
                ShortName: 'social-issues',
                Link: 'https://www.youtube.com/embed/UlPYBwDfzJg?rel=0&modestbranding=1',
              },
            ],
          },
        ],
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      IntroTitle: 'Listening Tracks',
      Intro: '',
      ProductTitle: '',
      AdditionalInfo: '',
      TrackFilePaths: [],
    },
    MenuBar: [
      {
        Text: 'Home',
        ImagePath: '/assets/images/landing/home.png',
        DestinationPage: '',
      },
      {
        Text: 'Quick Quiz',
        ImagePath: '/assets/images/landing/quick-quizzes.png',
        DestinationPage: 'Quick-Quiz',
      },
      {
        Text: 'Mistakes Quiz',
        ImagePath: '/assets/images/landing/your-mistakes-quiz.png',
        DestinationPage: 'Mistakes-Quiz',
        MenuType: MenuItemTypeEnum.MistakesQuiz,
      },
      {
        Text: 'Summary Test',
        ImagePath: '/assets/images/landing/revision-summary-test.png',
        DestinationPage: 'Revision-Summary-Test',
      },
      {
        Text: 'Level',
        ImagePath: '/assets/images/landing/h-f-level.png',
        DestinationPage: 'CookieSwitcher',
        MenuType: MenuItemTypeEnum.HighFoundationSwitch,
      },
    ],
    HowToRevise: {
      DisplayName: '',
      BookType: '',
      AdditionalText: '',
    },
  },
  {
    MenuItemType: MenuItemTypeEnum.ListeningTracks,
    IsFreeSample: false,
    Anchor: '',
    ButtonColour: '#FF9335',
    ButtonCustomClasses: '',
    ButtonText: 'Listen now',
    ButtonURL: 'listening',
    MixedOnlineTests: [],

    HasData: false,
    HeadingText: 'Listening Tracks',
    IsButtonDisabled: false,
    IsSwitcher: false,
    MainContentText:
      '<p>All the audio you&rsquo;ll need to answer the listening questions in your book.</p>\n',
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'Audio for all listening questions',
    SwitcherCookieName: 'CgpDigitalRevision',
    SwitcherProductCode: '',
    ExtrasOrAnswers: {
      HeaderText: '',
      ContentMain: '',
      ContentRight: {
        ImageUrl: '',
        AltText: '',
      },
    },
    HowToUseThisBook: {
      Text: '',
      VideoLink: '',
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        Intro: '',
        Title: '',
        LeftSections: [],
        RightSections: [],
      },
    ],
    MenuBar: [
      {
        Text: 'Home',
        ImagePath: '/assets/images/landing/home.png',
        DestinationPage: '',
      },
      {
        Text: 'Quick Quiz',
        ImagePath: '/assets/images/landing/quick-quizzes.png',
        DestinationPage: 'Quick-Quiz',
      },
      {
        Text: 'Mistakes Quiz',
        ImagePath: '/assets/images/landing/your-mistakes-quiz.png',
        DestinationPage: 'Mistakes-Quiz',
        MenuType: MenuItemTypeEnum.MistakesQuiz,
      },
      {
        Text: 'Summary Test',
        ImagePath: '/assets/images/landing/revision-summary-test.png',
        DestinationPage: 'Revision-Summary-Test',
      },
      {
        Text: 'Level',
        ImagePath: '/assets/images/landing/h-f-level.png',
        DestinationPage: 'CookieSwitcher',
        MenuType: MenuItemTypeEnum.HighFoundationSwitch,
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      IntroTitle: 'Listening Tracks',
      Intro:
        'Listen carefully... Do you hear the sound of practice listening questions? ¡Sí! Choose a track to get started.',
      ProductTitle: 'GCSE AQA Spanish Complete Revision & Practice',
      AdditionalInfo: '',
      TrackFilePaths: [
        '[[cloudfront_url]]/_revisionhub_opc/SPAS43/Audio/listening-tracks/01-listening-track-1-numbers-and-times.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/SPAS43/Audio/listening-tracks/02-listening-track-2-times-and-dates.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/SPAS43/Audio/listening-tracks/03-listening-track-3-opinions.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/SPAS43/Audio/listening-tracks/04-listening-track-4-questions.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/SPAS43/Audio/listening-tracks/05-listening-track-5-questions.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/SPAS43/Audio/listening-tracks/06-listening-track-6-describing-people.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/SPAS43/Audio/listening-tracks/07-listening-track-7-relationships-and-partnerships.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/SPAS43/Audio/listening-tracks/08-listening-track-8-questions.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/SPAS43/Audio/listening-tracks/09-listening-track-9-questions.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/SPAS43/Audio/listening-tracks/10-listening-track-10-food.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/SPAS43/Audio/listening-tracks/11-listening-track-11-illnesses-and-treatments.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/SPAS43/Audio/listening-tracks/12-listening-track-12-questions.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/SPAS43/Audio/listening-tracks/13-listening-track-13-questions.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/SPAS43/Audio/listening-tracks/14-listening-track-14-school-life.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/SPAS43/Audio/listening-tracks/15-listening-track-15-school-pressures-and-difficulties.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/SPAS43/Audio/listening-tracks/16-listening-track-16-questions.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/SPAS43/Audio/listening-tracks/17-listening-track-17-questions.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/SPAS43/Audio/listening-tracks/18-listening-track-18-questions.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/SPAS43/Audio/listening-tracks/19-listening-track-19-questions.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/SPAS43/Audio/listening-tracks/20-listening-track-20-music.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/SPAS43/Audio/listening-tracks/21-listening-track-21-questions.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/SPAS43/Audio/listening-tracks/22-listening-track-22-questions.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/SPAS43/Audio/listening-tracks/23-listening-track-23-customs-and-festivals.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/SPAS43/Audio/listening-tracks/24-listening-track-24-questions.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/SPAS43/Audio/listening-tracks/25-listening-track-25-questions.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/SPAS43/Audio/listening-tracks/26-listening-track-26-favourite-celebrities.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/SPAS43/Audio/listening-tracks/27-listening-track-27-questions.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/SPAS43/Audio/listening-tracks/28-listening-track-28-questions.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/SPAS43/Audio/listening-tracks/29-listening-track-29-where-to-go.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/SPAS43/Audio/listening-tracks/30-listening-track-30-accommodation-and-travel.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/SPAS43/Audio/listening-tracks/31-listening-track-31-questions.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/SPAS43/Audio/listening-tracks/32-listening-track-32-questions.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/SPAS43/Audio/listening-tracks/33-listening-track-33-technology.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/SPAS43/Audio/listening-tracks/34-listening-track-34-the-internet.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/SPAS43/Audio/listening-tracks/35-listening-track-35-questions.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/SPAS43/Audio/listening-tracks/36-listening-track-36-questions.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/SPAS43/Audio/listening-tracks/37-listening-track-37-directions-and-weather.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/SPAS43/Audio/listening-tracks/38-listening-track-38-questions.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/SPAS43/Audio/listening-tracks/39-listening-track-39-questions.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/SPAS43/Audio/listening-tracks/40-listening-track-40-protecting-the-environment.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/SPAS43/Audio/listening-tracks/41-listening-track-41-social-issues.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/SPAS43/Audio/listening-tracks/42-listening-track-42-questions.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/SPAS43/Audio/listening-tracks/43-listening-track-43-questions.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/SPAS43/Audio/listening-tracks/44-spanish-pronunciation.mp3',
      ],
    },
    HowToRevise: {
      DisplayName: '',
      BookType: '',
      AdditionalText: '',
    },
  },
  {
    MenuItemType: MenuItemTypeEnum.PracticePapers,
    IsFreeSample: false,
    Anchor: '',
    ButtonColour: '',
    ButtonCustomClasses: '',
    ButtonText: 'Go to Practice Papers',
    ButtonURL: 'practice-papers',
    MixedOnlineTests: [],

    HasData: false,
    HeadingText: 'Practice Papers',
    IsButtonDisabled: false,
    IsSwitcher: false,
    MainContentText:
      '<p>Ready to try the real thing? Print out a practice exam and have a go!</p>\n',
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'Full exam practice with audio\n',
    SwitcherCookieName: 'CgpDigitalRevision',
    SwitcherProductCode: '',
    ExtrasOrAnswers: {
      HeaderText: '',
      ContentMain: '',
      ContentRight: {
        ImageUrl: '',
        AltText: '',
      },
    },
    HowToUseThisBook: {
      Text: '',
      VideoLink: '',
    },
    PracticePapers: {
      Content:
        '<p>Choose the right Practice Paper for your level and test yourself in exam conditions. Download your practice exam and audio below. Your answer sheet and audio transcript are in <a href="/products/spas43/extras" style="color: rgb(20, 148, 212);">Extra Useful Bits</a>. Good luck!</p>\n' +
        '\n' +
        '<h3 class="wrapper-header">GCSE Spanish Higher Papers</h3>\n' +
        '\n' +
        '<p><a href="[[cloudfront_url]]/_revisionhub_opc/SPAS43/PDFs/cgp-gcse-spanish-listening-higher-paper.pdf" style="color: rgb(20, 148, 212);" target="_blank">Listening Higher Paper</a>&nbsp;&mdash; you can find the audio track&nbsp;<a href="/products/spas43/practice-papers/higher-audio" style="color: rgb(20, 148, 212);">here</a>.</p>\n' +
        '\n' +
        '<p><a href="[[cloudfront_url]]/_revisionhub_opc/SPAS43/PDFs/cgp-gcse-spanish-listening-transcripts-higher.pdf" style="color: rgb(20, 148, 212);" target="_blank">Listening Higher Paper Transcript</a></p>\n' +
        '\n' +
        '<p><a href="[[cloudfront_url]]/_revisionhub_opc/SPAS43/PDFs/cgp-gcse-spanish-speaking-higher-paper.pdf" style="color: rgb(20, 148, 212);" target="_blank">Speaking Higher Paper</a></p>\n' +
        '\n' +
        '<p><a href="[[cloudfront_url]]/_revisionhub_opc/SPAS43/PDFs/cgp-gcse-spanish-reading-higher-paper.pdf" style="color: rgb(20, 148, 212);" target="_blank">Reading Higher Paper</a></p>\n' +
        '\n' +
        '<p><a href="[[cloudfront_url]]/_revisionhub_opc/SPAS43/PDFs/cgp-gcse-spanish-writing-higher-paper.pdf" style="color: rgb(20, 148, 212);" target="_blank">Writing Higher Paper</a></p>\n' +
        '\n' +
        '<p><a href="[[cloudfront_url]]/_revisionhub_opc/SPAS43/PDFs/cgp-gcse-spanish-answers-higher-papers.pdf" style="color: rgb(20, 148, 212);" target="_blank">Higher Paper &mdash; Answers</a></p>\n' +
        '&nbsp;\n' +
        '\n' +
        '<h3 class="wrapper-header">GCSE Spanish Foundation Papers</h3>\n' +
        '\n' +
        '<p><a href="[[cloudfront_url]]/_revisionhub_opc/SPAS43/PDFs/cgp-gcse-spanish-listening-foundation-paper.pdf" style="color: rgb(20, 148, 212);" target="_blank">Listening Foundation Paper</a>&nbsp;&mdash; you can find the audio track&nbsp;<a href="/products/spas43/practice-papers/foundation-audio" style="color: rgb(20, 148, 212);">here</a>.</p>\n' +
        '\n' +
        '<p><a href="[[cloudfront_url]]/_revisionhub_opc/SPAS43/PDFs/cgp-gcse-spanish-listening-transcripts-foundation.pdf" style="color: rgb(20, 148, 212);" target="_blank">Listening&nbsp;Foundation Paper Transcript</a></p>\n' +
        '\n' +
        '<p><a href="[[cloudfront_url]]/_revisionhub_opc/SPAS43/PDFs/cgp-gcse-spanish-speaking-foundation-paper.pdf" style="color: rgb(20, 148, 212);" target="_blank">Speaking Foundation Paper</a></p>\n' +
        '\n' +
        '<p><a href="[[cloudfront_url]]/_revisionhub_opc/SPAS43/PDFs/cgp-gcse-spanish-reading-foundation-paper.pdf" style="color: rgb(20, 148, 212);" target="_blank">Reading Foundation Paper</a></p>\n' +
        '\n' +
        '<p><a href="[[cloudfront_url]]/_revisionhub_opc/SPAS43/PDFs/cgp-gcse-spanish-writing-foundation-paper.pdf" style="color: rgb(20, 148, 212);" target="_blank">Writing Foundation Paper</a></p>\n' +
        '\n' +
        '<p><a href="[[cloudfront_url]]/_revisionhub_opc/SPAS43/PDFs/cgp-gcse-spanish-answers-foundation-papers.pdf" style="color: rgb(20, 148, 212);" target="_blank">Foundation Paper &mdash; Answers</a></p>\n',
      Audio: [
        {
          TestLevel: TestLevelEnum.Higher,
          ProductTitle: 'Higher Listening Paper &mdash; Audio',
          TrackFilePaths: [
            '[[cloudfront_url]]/_revisionhub_opc/SPAS43/Audio/higher/45-higher-listening-paper.mp3',
          ],
        },
        {
          TestLevel: TestLevelEnum.Foundation,
          ProductTitle: 'Foundation Listening Paper &mdash; Audio',
          TrackFilePaths: [
            '[[cloudfront_url]]/_revisionhub_opc/SPAS43/Audio/foundation/46-foundation-listening-paper.mp3',
          ],
        },
      ],
    },
    QAndA: [
      {
        Intro: '',
        Title: '',
        LeftSections: [],
        RightSections: [],
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      IntroTitle: '',
      Intro: '',
      ProductTitle: '',
      AdditionalInfo: '',
      TrackFilePaths: [],
    },
    MenuBar: [
      {
        Text: 'Home',
        ImagePath: '/assets/images/landing/home.png',
        DestinationPage: '',
      },
      {
        Text: 'Quick Quiz',
        ImagePath: '/assets/images/landing/quick-quizzes.png',
        DestinationPage: 'Quick-Quiz',
      },
      {
        Text: 'Mistakes Quiz',
        ImagePath: '/assets/images/landing/your-mistakes-quiz.png',
        DestinationPage: 'Mistakes-Quiz',
        MenuType: MenuItemTypeEnum.MistakesQuiz,
      },
      {
        Text: 'Summary Test',
        ImagePath: '/assets/images/landing/revision-summary-test.png',
        DestinationPage: 'Revision-Summary-Test',
      },
      {
        Text: 'Level',
        ImagePath: '/assets/images/landing/h-f-level.png',
        DestinationPage: 'CookieSwitcher',
        MenuType: MenuItemTypeEnum.HighFoundationSwitch,
      },
    ],
    HowToRevise: {
      DisplayName: '',
      BookType: '',
      AdditionalText: '',
    },
  },
  {
    MenuItemType: MenuItemTypeEnum.Extras,
    IsFreeSample: false,
    Anchor: '',
    ButtonColour: '',
    ButtonCustomClasses: '',
    ButtonText: 'View Extras',
    MixedOnlineTests: [],

    ButtonURL: 'extras',
    HasData: false,
    HeadingText: 'Extra Useful Bits',
    IsButtonDisabled: false,
    IsSwitcher: false,
    MainContentText:
      '<p>Printable answers, transcripts, and vocabulary lists — yep, it\'s all right here. </p>',
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'Other resources to download',
    SwitcherCookieName: 'CgpDigitalRevision',
    SwitcherProductCode: '',
    HowToUseThisBook: {
      Text: 'We\'ve put together lots of helpful information on how to get the most out of your Complete Revision & Practice. And if you\'ve hit any snags, you\'ll find the answers you need here too. ¡Qué bien!',
      VideoLink: 'https://www.youtube.com/embed/-TqrRoP-g9I?rel=0&modestbranding=1',
    },
    ExtrasOrAnswers: {
      HeaderText: 'Extra Useful Bits',
      ContentMain:
        '<p>Your<strong> listening transcripts</strong>, <strong>Revision Summary Test answers</strong> and <strong>vocabulary lists</strong> are below. Take your pick!</p>\n' +
        '\n' +
        '<p><a href="[[cloudfront_url]]/_revisionhub_opc/SPAS43/PDFs/cgp-gcse-spanish-vocabulary-lists-higher.pdf" style="color: rgb(20, 148, 212);" target="_blank">Vocabulary Lists &mdash; Higher</a></p>\n' +
        '\n' +
        '<p><a href="[[cloudfront_url]]/_revisionhub_opc/SPAS43/PDFs/cgp-gcse-spanish-vocabulary-lists-foundation.pdf" style="color: rgb(20, 148, 212);" target="_blank">Vocabulary Lists &mdash; Foundation</a></p>\n' +
        '\n' +
        '<p><a href="[[cloudfront_url]]/_revisionhub_opc/SPAS43/PDFs/cgp-gcse-spanish-grammar-lists.pdf" style="color: rgb(20, 148, 212);" target="_blank">Grammar Lists</a></p>\n' +
        '\n' +
        '<p><a href="[[cloudfront_url]]/_revisionhub_opc/SPAS43/PDFs/cgp-gcse-spanish-revision-summary-answers.pdf" style="color: rgb(20, 148, 212);" target="_blank">Revision Summary Answers</a></p>\n' +
        '\n' +
        '<p><a href="[[cloudfront_url]]/_revisionhub_opc/SPAS43/PDFs/cgp-gcse-spanish-transcripts.pdf" style="color: rgb(20, 148, 212);" target="_blank">Audio Transcripts</a></p>\n',
      ContentRight: {
        ImageUrl: '/assets/images/useful-bits-toucan.png',
        AltText: 'Fun image of toucan peeking out from behind the useful PDFs',
      },
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        Intro: '',
        Title: '',
        LeftSections: [],
        RightSections: [],
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      IntroTitle: 'Listening Tracks',
      Intro: '',
      ProductTitle: '',
      AdditionalInfo: '',
      TrackFilePaths: [],
    },
    MenuBar: [
      {
        Text: 'Home',
        ImagePath: '/assets/images/landing/home.png',
        DestinationPage: '',
      },
      {
        Text: 'Quick Quiz',
        ImagePath: '/assets/images/landing/quick-quizzes.png',
        DestinationPage: 'Quick-Quiz',
      },
      {
        Text: 'Mistakes Quiz',
        ImagePath: '/assets/images/landing/your-mistakes-quiz.png',
        DestinationPage: 'Mistakes-Quiz',
        MenuType: MenuItemTypeEnum.MistakesQuiz,
      },
      {
        Text: 'Summary Test',
        ImagePath: '/assets/images/landing/revision-summary-test.png',
        DestinationPage: 'Revision-Summary-Test',
      },
      {
        Text: 'Level',
        ImagePath: '/assets/images/landing/h-f-level.png',
        DestinationPage: 'CookieSwitcher',
        MenuType: MenuItemTypeEnum.HighFoundationSwitch,
      },
    ],
    HowToRevise: {
      DisplayName: '',
      BookType: '',
      AdditionalText: '',
    },
  },
  {
    MenuItemType: MenuItemTypeEnum.HighFoundationSwitch,
    IsFreeSample: false,
    Anchor: '',
    ButtonColour: '',
    ButtonCustomClasses: '',
    ButtonText: 'Switch',
    ButtonURL: '',
    MixedOnlineTests: [],

    HasData: true,
    HeadingText: 'Higher or Foundation',
    IsButtonDisabled: false,
    IsSwitcher: true,
    MainContentText: function () {
      if (typeof document !== 'undefined') {
        const match = document.cookie.match(/(?:^|; )CgpDigitalRevision=([^;]*)/);
        const value = match ? decodeURIComponent(match[1]) : '';
        if (value === 'Foundation') {
          return `<p>You&#39;re working at <strong>Foundation Level</strong></p>\n\n<p>Switch to <strong>Higher Level</strong>?</p>`;
        }
        if (value === 'Higher') {
          return `<p>You&#39;re working at <strong>Higher Level</strong></p><p>Switch to <strong>Foundation Level</strong>?</p>`;
        }
      }
      return '';
    },
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'Choose your exam level',
    SwitcherCookieName: 'CgpDigitalRevision',
    SwitcherProductCode: '',
    ExtrasOrAnswers: {
      HeaderText: '',
      ContentMain: '',
      ContentRight: {
        ImageUrl: '',
        AltText: '',
      },
    },
    HowToUseThisBook: {
      Text: '',
      VideoLink: '',
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        Intro: '',
        Title: '',
        LeftSections: [],
        RightSections: [],
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      IntroTitle: 'Listening Tracks',
      Intro: '',
      ProductTitle: '',
      AdditionalInfo: '',
      TrackFilePaths: [],
    },
    MenuBar: [
      {
        Text: 'Home',
        ImagePath: '/assets/images/landing/home.png',
        DestinationPage: '',
      },
      {
        Text: 'Quick Quiz',
        ImagePath: '/assets/images/landing/quick-quizzes.png',
        DestinationPage: 'Quick-Quiz',
      },
      {
        Text: 'Mistakes Quiz',
        ImagePath: '/assets/images/landing/your-mistakes-quiz.png',
        DestinationPage: 'Mistakes-Quiz',
        MenuType: MenuItemTypeEnum.MistakesQuiz,
      },
      {
        Text: 'Summary Test',
        ImagePath: '/assets/images/landing/revision-summary-test.png',
        DestinationPage: 'Revision-Summary-Test',
      },
      {
        Text: 'Level',
        ImagePath: '/assets/images/landing/h-f-level.png',
        DestinationPage: 'CookieSwitcher',
        MenuType: MenuItemTypeEnum.HighFoundationSwitch,
      },
    ],
    HowToRevise: {
      DisplayName: '',
      BookType: '',
      AdditionalText: '',
    },
  },
  {
    MenuItemType: MenuItemTypeEnum.NeedHelp,
    IsFreeSample: false,
    Anchor: '',
    ButtonColour: '',
    ButtonCustomClasses: '',
    ButtonText: 'Take a look',
    ButtonURL: '',
    MixedOnlineTests: [],

    HasData: false,
    HeadingText: 'Need some help?',
    IsButtonDisabled: false,
    IsSwitcher: false,
    MainContentText:
      '<p>Watch our useful video to get started or take a look at the FAQs if you need some help.</p>\n',
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'Check out our video and FAQs',
    SwitcherCookieName: 'CgpDigitalRevision',
    SwitcherProductCode: '',
    ExtrasOrAnswers: {
      HeaderText: '',
      ContentMain: '',
      ContentRight: {
        ImageUrl: '',
        AltText: '',
      },
    },
    HowToUseThisBook: {
      TagLine: 'We\'ve put together lots of helpful information on how to get the most out of your Complete Revision & Practice. And if you\'ve hit any snags, you\'ll find the answers you need here too. ¡Qué bien!',
      Text: '  <h2>Frequently Asked Questions</h2>\n' +
        '\n' +
        '<h5>What is CGP RevisionHub?&nbsp;</h5>\n' +
        '\n' +
        '<p>Great question! CGP RevisionHub is our online platform where you can find lots of helpful revision, all matched to your GCSE Languages books. Use the quizzes, tests, audio and more to practise what you\'ve learned from your book and revise for your exams.&nbsp;<br>\n' +
        '&nbsp;</p>\n' +
        '\n' +
        '<h5>What equipment do I need to use CGP RevisionHub?&nbsp;</h5>\n' +
        '\n' +
        '<p>You can access CGP RevisionHub on your computer, tablet or phone. Just make sure your device can connect to the internet. Wearing a spinny propellor hat is not required, but it is cool though.&nbsp;<br>\n' +
        '&nbsp;</p>\n' +
        '\n' +
        '<h5>How do I use CGP RevisionHub with my book?&nbsp;</h5>\n' +
        '\n' +
        '<p>You\'ll notice lots of QR codes scattered throughout your book. Just give them a scan and you\'ll automatically be taken to the relevant quiz, audio or other revision thingy-ma-jig so you can practise exactly what you\'ve just learned!&nbsp;<br>\n' +
        '&nbsp;</p>\n' +
        '\n' +
        '<h5>My RevisionHub isn’t working — what do I do?&nbsp;</h5>\n' +
        '\n' +
        '<p>If you can’t find the answer in these FAQs, it\'s time to contact our friendly <a href="#contact" style="color: #1494D4;">Customer Services team</a>.&nbsp;&nbsp;</p>\n' +
        '\n' +
        '<p>You could also try \'stop, drop and roll\', but that might be for another problem...&nbsp;<br>\n' +
        '&nbsp;</p>\n' +
        '\n' +
        '<h5>Do I need an internet connection to use CGP RevisionHub?&nbsp;</h5>\n' +
        '\n' +
        '<p>Yes, you do. But don\'t cancel your revision retreat to a remote mountain cave just yet — there are also lots of useful bits that you can download as PDFs to access offline. Phew.&nbsp;<br>\n' +
        '&nbsp;</p>\n' +
        '\n' +
        '<h5>If I log in on a different device, will all my progress be saved?&nbsp;</h5>\n' +
        '\n' +
        '<p>Yep. Just log in on your computer, tablet or phone, and all your progress and stats will be there waiting for you.&nbsp;<br>\n' +
        '&nbsp;</p>\n' +
        '\n' +
        '<h5>What’s the difference between the Quick Quizzes, Your Mistakes Quiz and Revision Summary Tests?&nbsp;</h5>\n' +
        '\n' +
        '<p>Quick Quizzes are...well, quick! They\'re a speedy way to test all the vocab and grammar on the course. There\'s lots of Quick Quizzes dotted throughout your book to get stuck into.&nbsp;</p>\n' +
        '\n' +
        '<p>Your Mistakes Quiz tests you on all the questions you got wrong in your Quick Quizzes. It\'s really helpful for targeting those bits you find trickier.</p>\n' +
        '\n' +
        '<p>Revision Summary Tests include more challenging questions — if you can do them all, you know you\'ve covered everything. You\'ll find a test at the end of every section in your book and you can mark them yourself using our example answers.&nbsp;<br>\n' +
        '&nbsp;</p>\n' +
        '\n' +
        '<h5>What happens when I switch between Higher and Foundation level?&nbsp;</h5>\n' +
        '\n' +
        '<p>You can switch between Higher and Foundation level as much as you want. When you\'re using Foundation level, you won\'t be able to see any Higher level Quizzes or Revision Summary Test questions. But don\'t worry — all your progress and scores from Higher level will still be saved.<br>\n' +
        '&nbsp;</p>\n' +
        '\n' +
        '<h5>Why are there Revision Summary Test questions in my book that I can’t see online?&nbsp;</h5>\n' +
        '\n' +
        '<p>If your level is set to Foundation, you won\'t be able to see the Higher questions in the CGP RevisionHub. To find out more about switching between Foundation and Higher, check out the FAQ above.&nbsp;<br>\n' +
        '&nbsp;</p>\n' +
        '\n' +
        '<h5>Can I clear my progress so far in the Hub and start again?&nbsp;</h5>\n' +
        '\n' +
        '<p>There are no takie-backsies in RevisionHub, so you can\'t clear your results and start again. But practice makes perfect, and you can take the quizzes as many times as you want to improve your scores. Plus, you can edit your Revision Summary Test answers as your skills and understanding develop. Keep going, we believe in you!&nbsp;<br>\n' +
        '&nbsp;</p>\n' +
        '\n' +
        '<h5>Can I share my quiz scores and test results with other people?&nbsp;</h5>\n' +
        '\n' +
        '<p>You can\'t share results directly via CGP RevisionHub, but there are other means… Carrier pigeons and smoke signals are both great options. Or you could just tell them, but where\'s the fun in that?&nbsp;<br>\n' +
        '&nbsp;</p>\n' +
        '\n' +
        '<h5>What happens when I’ve answered all the questions?&nbsp;</h5>\n' +
        '\n' +
        '<p>Ah, one of life\'s greatest questions — what next? We\'d recommend that you keep practising right up until your exams. Much better than falling into a pit of existential dread, but you do you.<br>\n' +
        '&nbsp;</p>\n' +
        '\n' +
        '<h5>Will I always have access to CGP RevisionHub?&nbsp;</h5>\n' +
        '\n' +
        '<p>Once you use a code, you\'ll have access for three years. And they’ll be three whole years of bliss, we promise.&nbsp;<br>\n' +
        '&nbsp;</p>',
      VideoLink: 'https://www.youtube.com/embed/XDJoaaCnChY?rel=0&modestbranding=1',
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        Intro: '',
        Title: '',
        LeftSections: [],
        RightSections: [],
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      IntroTitle: 'Listening Tracks',
      Intro: '',
      ProductTitle: '',
      AdditionalInfo: '',
      TrackFilePaths: [],
    },
    MenuBar: [
      {
        Text: 'Home',
        ImagePath: '/assets/images/landing/home.png',
        DestinationPage: '',
      },
      {
        Text: 'Quick Quiz',
        ImagePath: '/assets/images/landing/quick-quizzes.png',
        DestinationPage: 'Quick-Quiz',
      },
      {
        Text: 'Mistakes Quiz',
        ImagePath: '/assets/images/landing/your-mistakes-quiz.png',
        DestinationPage: 'Mistakes-Quiz',
        MenuType: MenuItemTypeEnum.MistakesQuiz,
      },
      {
        Text: 'Summary Test',
        ImagePath: '/assets/images/landing/revision-summary-test.png',
        DestinationPage: 'Revision-Summary-Test',
      },
      {
        Text: 'Level',
        ImagePath: '/assets/images/landing/h-f-level.png',
        DestinationPage: 'CookieSwitcher',
        MenuType: MenuItemTypeEnum.HighFoundationSwitch,
      },
    ],
    HowToRevise: {
      DisplayName: '',
      BookType: '',
      AdditionalText: '',
    },
  },
  {
    MenuItemType: MenuItemTypeEnum.MoreFromCGP,
    IsFreeSample: false,
    Anchor: '',
    ButtonColour: '',
    ButtonCustomClasses: '',
    ButtonText: 'See more CGP revision',
    ButtonURL: '[[external_domain]]/secondary-books/gcse',
    MixedOnlineTests: [],

    HasData: false,
    HeadingText: 'More from CGP',
    IsButtonDisabled: false,
    IsSwitcher: false,
    MainContentText:
      'There\'s plenty more revision where this came from! Take a look at some of our other revision books.',
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'Everything you need for revision!',
    SwitcherCookieName: 'CgpDigitalRevision',
    SwitcherProductCode: '',
    ExtrasOrAnswers: {
      HeaderText: '',
      ContentMain: '',
      ContentRight: {
        ImageUrl: '',
        AltText: '',
      },
    },
    HowToUseThisBook: {
      Text: '',
      VideoLink: '',
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        Intro: '',
        Title: '',
        LeftSections: [],
        RightSections: [],
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      IntroTitle: 'Listening Tracks',
      Intro: '',
      ProductTitle: '',
      AdditionalInfo: '',
      TrackFilePaths: [],
    },
    MenuBar: [],
    HowToRevise: {
      DisplayName: '',
      BookType: '',
      AdditionalText: '',
    },
  },
];
